export enum MetadataType {
    Source = 1,
}